import studentIdLoginDirective from 'html/claim/student-id-login-directive.html';
import App from 'app/app.js';
import 'app/directive/LtSchoolSearchCtrl.js';

function LtStudentIdLogInDirective() {
  return {
    restrict: 'E',
    scope: {
      studentIdSignInFlow: '=',
      isInModal: '=',
      studentIdNewClaimForm: '=',
      onCancel: '&',
      email: '=',
      fromBannerPage: '=',
      fromLoginPopup: '='
    },
    template: studentIdLoginDirective,
    controller: 'LoginCtrl',
    controllerAs: 'login'
  };
}

App.directive('ltStudentIdLogin', [LtStudentIdLogInDirective]);
